import type { FunctionComponentWithRef } from "react";
import { graphql, useFragment } from "react-relay";

import { withHighlightedHeadline } from "scmp-app/components/content/content-item-render/highlight/hoc";
import { useContentItemProviders } from "scmp-app/components/content/content-item-render/hooks";
import type { ContentItemRenderVariantProps } from "scmp-app/components/content/content-item-render/types";
import type { homeAroundSecondaryV2ContentItemContent$key } from "scmp-app/queries/__generated__/homeAroundSecondaryV2ContentItemContent.graphql";

import { Container, Content, Headline, StyledEntityLink } from "./styles";

export type Props = ContentItemRenderVariantProps & {
  reference: homeAroundSecondaryV2ContentItemContent$key;
};

const Component: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  onClick,
  ref,
  reference,
}) => {
  const content = useFragment(
    graphql`
      fragment homeAroundSecondaryV2ContentItemContent on Content {
        entityId
        urlAlias
        ...entityLink
        ...hooksContentItemProvidersContent @arguments(withHeadline: true)
      }
    `,
    reference,
  );
  const providers = useContentItemProviders(content);

  return (
    <Container className={className} ref={ref}>
      <StyledEntityLink
        onClick={() => onClick?.(content.entityId, content.urlAlias)}
        reference={content}
      >
        <Content>
          <Headline>
            {providers.headline({
              hideTooltip: true,
              preferSocialHeadline: true,
              skipHeadlineSponsorStyle: true,
            })}
          </Headline>
        </Content>
      </StyledEntityLink>
    </Container>
  );
};

Component.displayName = "ContentItemHomeAroundSecondaryV2";

export const ContentItemHomeAroundSecondaryV2 = withHighlightedHeadline(Component);
